<template>
  <!-- A public route carries its own authorisation in the URL and is reached by people
       who have no account here at all, so it gets neither the login gate nor the nav. -->
  <RouterView v-if="route.meta.public" />
  <div v-else-if="!auth.isLoggedIn">
    <LoginView />
  </div>
  <template v-else>
    <HeaderErpNav v-if="useErpMenu" />
    <HeaderNav v-else />

    <RouterView />
  </template>
</template>

<script setup>
import { RouterView, useRoute, useRouter } from 'vue-router'
import { getCookie } from '@/utils'
import { onBeforeMount, watch } from 'vue'
import { useAuthStore } from '@/auth'
import LoginView from '@/views/LoginView.vue'
import HeaderNav from './components/HeaderNav.vue'
import HeaderErpNav from './components/HeaderErpNav.vue'
import { useErpMenu } from '@/erpMenu'

const route = useRoute()
const router = useRouter()
const auth = useAuthStore()

onBeforeMount(async () => {
  await auth.fetchUserData(getCookie('access_token'))
})

watch(
  () => auth.userData,
  async (userData) => {
    if (!userData) return
    await router.isReady()
    if (router.currentRoute.value.name !== 'tickets-list') return
    const hasTicketsTab = auth.roles.some(
      (r) => r.includes('tickets_v2') || r.includes('admin')
    )
    if (!hasTicketsTab && auth.hasPermission('Eleena:register_meters')) {
      router.replace({ name: 'meter-activation' })
    }
  }
)

// Tickets' own pages always get the Tickets menu, also when linked from ERP; its ERP
// tab leads back.
const ticketsOwnRoutes = ['ticket', 'calendar', 'schedule', 'meter-activation']
router.afterEach((to) => {
  if (ticketsOwnRoutes.some((prefix) => String(to.name).startsWith(prefix))) {
    useErpMenu.value = false
  }
})
</script>

<style>
@import '@vueform/multiselect/themes/tailwind.css';
</style>
